import React from "react";
import 'normalize.css';
// import Header from "./Header";


export default function ContactUs() {
  return (
    <main id="content" className="content">
        {/* <Header/> */}
      <section
        className="vc_row fullheight d-flex flex-wrap align-items-center bg-cover pt-150 pb-150"
        style={{ backgroundImage: "url(assets/demo/bg/bg-14.jpg)" }}
        data-parallax="true"
        data-parallax-options={{ parallaxBG: true }}
      >
        <div className="container">
          <div className="row">
          <div className="lqd-column col-md-6">
  {/* First Row: Text Content */}
  <div className="row">
    <div className="col-12">
      <h1
        className="text-white pr-md-5 mt-0 mb-40"
        data-split-text="true"
        data-split-options={{ type: "lines" }}
      >
        Get in Touch With Us
      </h1>
      <p
        className="text-white font-size-16 lh-185 pr-md-7 mb-60"
        data-split-text="true"
        data-split-options={{ type: "lines" }}
      >
        Have any questions or need help? Feel free to reach out, and we’ll get back to you shortly!
      </p>
    </div>
  </div>
  {/* Second Row: Image */}
  <div className="row">
    <div className="col-12">
      <img src="assets/img/ContactUs/contact.jpg" alt="Contact Us" className="img-fluid" style={{ width: '80%', height: '80%' }} />
    </div>
  </div>
</div>

            <div className="lqd-column col-md-6 pt-40">
              <form className="contact-form">
                <div className="form-group">
                  <label htmlFor="name" className="text-white">
                    Your Name
                  </label>
                  <input
                    type="text"
                    id="name"
                    className="form-control"
                    placeholder="Enter your name"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email" className="text-white">
                    Your Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    className="form-control"
                    placeholder="Enter your email"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message" className="text-white">
                    Your Message
                  </label>
                  <textarea
                    id="message"
                    className="form-control"
                    rows="5"
                    placeholder="Write your message here"
                    required
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="btn btn-solid text-uppercase btn-md circle btn-bordered border-thin btn-gradient px-2"
                >
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Info Section */}
      <section className="vc_row bg-no-repeat pt-100 pb-100" style={{ backgroundImage: "url(assets/demo/bg/bg-76.svg)", backgroundPosition: "-90% 80%" }}>
        <div className="container">
          <div className="row">
            <div className="lqd-column col-md-4">
              <h3>Contact Information</h3>
              <p>
                <strong style={{ color: '#000' }}>Corporate Office -</strong> 
                <br></br>
                <strong style={{ color: '#333' }}>Pune:</strong> 

                
                <br></br>
                Novacred Pvt Ltd (DocBoyz), Office no-114,  <br></br> B- Wing SOHO Panchshil Wagholi, Pune, Maharashtra - 412207, India
                <br></br>
                
                <strong style={{ color: '#333' }}>Mumbai:</strong> 
                <br></br>


                C-106 Kanishka GE Links CHS, Ram Mandir Road Goregaon West, Mumbai -400104, India 
              </p>
              <p>
                <strong style={{ color: '#333' }}>Email:</strong>  info@docboyz.in
              </p>
              <p>
                <strong style={{ color: '#333' }}>Phone:</strong> +91 8470067555
              </p>
            </div>

            {/* Optional: Embed Google Map */}
            <div className="lqd-column col-md-8">
              <iframe
                // src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3151.8354345093424!2d144.9537353153154!3d-37.81627917975143!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad642af0f11fd81%3A0xf577350ba5f0a2df!2sVictoria!5e0!3m2!1sen!2sau!4v1510917516893"
                // src="https://www.google.com/maps/place/DocBoyz/@18.5464419,73.8982898,716m/data=!3m2!1e3!4b1!4m6!3m5!1s0x3bc2c19b18cb5311:0x26c8365c5a0a8069!8m2!3d18.5464368!4d73.9008647!16s%2Fg%2F11fnw95n6n?hl=en-US&entry=ttu&g_ep=EgoyMDI0MTAyMy4wIKXMDSoASAFQAw%3D%3D"
                src="assets/img/ContactUs/map.png"
                width="100%"
                height="400"
                allowFullScreen=""
                loading="lazy"
                title="Company Location"
              ></iframe>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
